import { DrEntity } from './dr-entity';
import { DrObject, DrObjectType, SupportedRegExType } from './dr-object';

export class Pattern extends DrEntity {
    createdBy: string;
    description: string;
    enabled: boolean;
    expression: string;
    name: string;
    storeValue: boolean;

    constructor(value?: Partial<Pattern>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }
}

export class PatternViewModel extends DrObject {
    model: Partial<Pattern>;
    original: Partial<Pattern>;
    constructor(value?: Partial<Pattern>) {
        super(DrObjectType.PATTERN_TOKEN_NAME, SupportedRegExType.PATTERNS);
        if (value) {
            this.model = value;
        }

        if (this.model) {
            this.original = new Pattern(this.model);
        }
    }

    isDirty(): boolean {
        if (this.model && this.original) {
            if (this.model.expression && (this.model.expression !== this.original.expression)) {
                return true;
            }

            if (this.model.storeValue !== this.original.storeValue) {
                return true;
            }

            if (this.model.enabled !== this.original.enabled) {
                return true;
            }
        }
        return false;
    }
}
